(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jtp-gift-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.JtpQuiz) return;
  var LEAD_KEY = 'jtp-quiz-lead';
  var LAST_KEY = 'jtp-quiz-last';
  var LAST_DAYS = 30;
  // Second CDN used only if the first one cannot be reached
  var CONFETTI = ['https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js', 'https://unpkg.com/canvas-confetti@1.9.3/dist/confetti.browser.min.js'];
  var RADIO = '<svg viewBox="0 0 24 24" width="14" height="14" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK = '<span class="jtp-quiz__check" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  // Textes de secours si un réglage de la section est vidé (les vrais textes viennent des attributs data-t-*)
  // Pictogrammes au trait (24×24, style « line ») : « Maman | maman:4 | icon:maman »
  var ICONS = {
    maman: '<circle cx="12" cy="8.2" r="3.4"/><path d="M8.6 7.4c1.6.2 3.6-.6 4.6-2.2.8 1.2 1.9 1.9 2.4 2M8.4 9.6c-.5 2.4-1.3 3.8-2.4 4.6M15.6 9.6c.5 2.4 1.3 3.8 2.4 4.6M5 21c.6-3.6 3.4-6 7-6s6.4 2.4 7 6"/>',
    papa: '<circle cx="12" cy="8" r="3.6"/><path d="M8.5 6.6c.6-1.9 2-2.9 3.5-2.9s2.9 1 3.5 2.9M5 21c.6-3.6 3.4-6 7-6s6.4 2.4 7 6M12 15.2 10.9 17l1.1 3.4 1.1-3.4z"/>',
    mamie: '<circle cx="12" cy="8.6" r="3.4"/><circle cx="12" cy="3.7" r="1.3"/><circle cx="10.5" cy="8.7" r="1.1"/><circle cx="13.5" cy="8.7" r="1.1"/><path d="M11.6 8.7h.8M5 21c.6-3.6 3.4-6 7-6s6.4 2.4 7 6"/>',
    papi: '<circle cx="12" cy="8" r="3.6"/><circle cx="10.5" cy="7.8" r="1.1"/><circle cx="13.5" cy="7.8" r="1.1"/><path d="M11.6 7.8h.8M10.5 10.3c.5.4 1 .5 1.5.5s1-.1 1.5-.5M5 21c.6-3.6 3.4-6 7-6s6.4 2.4 7 6"/>',
    grandsparents: '<circle cx="8" cy="9" r="2.7"/><circle cx="8" cy="5.3" r="1"/><circle cx="16" cy="9" r="2.7"/><path d="M14.8 8.8h2.4M2.5 20.5c.4-2.9 2.6-5 5.5-5 1.4 0 2.6.5 3.6 1.3M21.5 20.5c-.4-2.9-2.6-5-5.5-5-1.4 0-2.6.5-3.6 1.3"/>',
    coeur: '<path d="M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7z"/>',
    amis: '<circle cx="9" cy="7" r="4"/><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8"/>',
    enfant: '<path d="M9 12h.01M15 12h.01M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"/>',
    famille: '<path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M12 17.6l-2.7-2.6a1.8 1.8 0 0 1 2.7-2.3 1.8 1.8 0 0 1 2.7 2.3z"/>',
    alliances: '<circle cx="9" cy="14.5" r="5"/><circle cx="15" cy="14.5" r="5"/><path d="M13.6 6.4 15 4.2h2.4l1.4 2.2-2.6 2.8z"/>',
    livre: '<path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2zM22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z"/>',
    affiche: '<rect x="4" y="3" width="16" height="18" rx="1.5"/><rect x="7" y="6" width="10" height="9" rx=".5"/><path d="m7 13.5 3-3 2.5 2.5 1.5-1.5 3 3M8 18h8"/>',
    mug: '<path d="M6 2v2M10 2v2M14 2v2M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"/>',
    tshirt: '<path d="M20.4 3.5 16 2a4 4 0 0 1-8 0L3.6 3.5a2 2 0 0 0-1.3 2.2l.6 3.5a1 1 0 0 0 1 .8H6v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10h2.2a1 1 0 0 0 1-.8l.6-3.5a2 2 0 0 0-1.4-2.2z"/>',
    larme: '<path d="M12 3.5s-5.5 6-5.5 9.8a5.5 5.5 0 0 0 11 0C17.5 9.5 12 3.5 12 3.5z"/><path d="M9.5 13.5A2.5 2.5 0 0 0 12 16"/>',
    rire: '<circle cx="12" cy="12" r="9.5"/><path d="M8 14s1.5 2.5 4 2.5 4-2.5 4-2.5M9 9h.01M15 9h.01"/>',
    maison: '<path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/>',
    etoile: '<path d="m12 2.5 2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z"/>',
    avion: '<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>',
    patte: '<circle cx="8" cy="6.5" r="1.7"/><circle cx="16" cy="6.5" r="1.7"/><circle cx="4.8" cy="11.5" r="1.6"/><circle cx="19.2" cy="11.5" r="1.6"/><path d="M12 12c-2.8 0-5 2.6-5 5 0 1.7 1.3 3 3 3 .8 0 1.4-.3 2-.3s1.2.3 2 .3c1.7 0 3-1.3 3-3 0-2.4-2.2-5-5-5z"/>',
    trophee: '<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.7V17c0 .6-.5 1-1 1.2C7.9 18.8 7 20.2 7 22M14 14.7V17c0 .6.5 1 1 1.2 1.1.6 2 2 2 3.8M18 2H6v7a6 6 0 0 0 12 0z"/>',
    musique: '<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
    cinema: '<rect x="2.5" y="9" width="19" height="12" rx="1.5"/><path d="m3.2 9-.9-3.4 16.4-4.4.9 3.4L3.2 9zM7.5 3.9l2.4 3M12.4 2.6l2.4 3"/>',
    photo: '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/><circle cx="12" cy="13" r="3.5"/>',
    plume: '<path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/>',
    magie: '<path d="m9.9 14.1-1.4 5.4-1.4-5.4-5.6-1.6 5.6-1.4 1.4-5.6 1.4 5.6 5.6 1.4zM18 3v4M16 5h4M19 15v3M17.5 16.5h3"/>',
    cadeau: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C9.5 3 12 8 12 8s2.5-5 4.5-5a2.5 2.5 0 0 1 0 5"/>',
    question: '<circle cx="12" cy="12" r="9.5"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6M12 17h.01"/>'
  };
  function icon(name, size) {
    var body = ICONS[name];
    return body ? '<svg viewBox="0 0 24 24" width="' + (size || 30) + '" height="' + (size || 30) + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>' : '';
  }
  // Mots-clés normalisés d'un produit (titre, type, tags, handle) : « T-Shirt Maman » -> ["tshirt", "maman", …]
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function words(p) {
    var raw = [p.title, p.product_type, p.vendor].concat(p.tags || []).join(' ') + ' ' + String(p.handle || '').replace(/-/g, ' ');
    var out = [];
    norm(raw).split(/[\s,;/|()]+/).forEach(function (w) {
      var j = w.replace(/[^a-z0-9]/g, '');
      if (j) out.push(j);
      if (w.indexOf('-') > -1) w.split('-').forEach(function (x) { x = x.replace(/[^a-z0-9]/g, ''); if (x) out.push(x); });
    });
    return out;
  }
  function hit(ws, tag) { var k = norm(tag).replace(/[^a-z0-9]/g, ''); return k.length > 1 && ws.some(function (w) { return w.indexOf(k) === 0; }); }
  var TXT = { copied: 'Copié ✓', phone: 'Ce numéro de téléphone semble incomplet.', step: 'Question {n} sur {total}', resume: 'Revoir ma sélection' };
  var PROBED = ['--qz-p-accent', '--qz-p-on-accent', '--qz-p-text', '--qz-p-text-a', '--qz-p-surface', '--qz-p-radius', '--qz-p-btn-radius', '--qz-heading-font', '--qz-heading-weight', '--qz-heading-ls'];
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var uid = 0;

  function reduced() { return !!(RM && RM.matches); }
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  // Racine de la langue / du marché courant (/en/, /fr-be/…)
  function rootUrl() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function sized(src, w) {
    if (!src || /[?&]width=/.test(src)) return src || '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getJSON(url) {
    if (!window.fetch) return Promise.reject(new Error('fetch'));
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var opt = cur ? { style: 'currency', currency: cur } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    var langs = [document.documentElement.lang || (window.Shopify && Shopify.locale) || undefined, undefined];
    for (var i = 0; i < langs.length; i++) { try { return new Intl.NumberFormat(langs[i], opt).format(n); } catch (e) {} }
    return n.toFixed(2) + (cur ? ' ' + cur : '');
  }
  // Multi-devises (Markets) : products.json renvoie les prix dans la devise de la boutique ;
  // si le visiteur voit une autre devise, on relit le prix converti via /products/<handle>.js (sinon prix masqué).
  function presentment(list) {
    var cur = window.Shopify && Shopify.currency, rate = cur ? parseFloat(cur.rate) : NaN;
    if (!list.length || !isFinite(rate) || Math.abs(rate - 1) < 1e-6) return list;
    var root = rootUrl();
    return Promise.all(list.map(function (p) {
      p._price = null;
      return getJSON(root + 'products/' + encodeURIComponent(p.handle) + '.js').then(function (d) {
        var v = d && d.variants && d.variants[0];
        if (v && isFinite(v.price)) { p._price = v.price / 100; p._cmp = v.compare_at_price ? v.compare_at_price / 100 : null; }
      }, function () {});
    })).then(function () { return list; });
  }
  // Envoi du formulaire client natif ; false si réseau KO ou redirection vers /challenge (anti-spam Shopify)
  function post(form) {
    if (!window.FormData) return Promise.resolve(false);
    var body = new FormData(form), url = form.action;
    var ok = function (status, finalUrl) { return status >= 200 && status < 400 && !/\/challenge\b/.test(finalUrl || ''); };
    if (window.fetch) {
      return fetch(url, { method: 'POST', body: body, credentials: 'same-origin' })
        .then(function (r) { return ok(r.status, r.url); }, function () { return false; });
    }
    return new Promise(function (res) {
      try {
        var x = new XMLHttpRequest();
        x.open('POST', url);
        x.onload = function () { res(ok(x.status, x.responseURL)); };
        x.onerror = function () { res(false); };
        x.send(body);
      } catch (e) { res(false); }
    });
  }
  var confettiP = null;
  function loadConfetti() {
    if (typeof window.confetti === 'function') return Promise.resolve();
    if (!confettiP) {
      var attempt = function (i) {
        return new Promise(function (res, rej) {
          var s = document.createElement('script');
          s.src = CONFETTI[i]; s.async = true; s.onload = res;
          s.onerror = function () { s.remove(); rej(new Error('confetti')); };
          (document.head || document.documentElement).appendChild(s);
        }).catch(function (e) { if (i + 1 < CONFETTI.length) return attempt(i + 1); confettiP = null; throw e; });
      };
      confettiP = attempt(0);
    }
    return confettiP;
  }

  /* ---------- Couleurs (sonde du thème) ---------- */
  var cvs = null;
  // Couleur calculée -> [r, g, b, a] ; oklch()/color()… convertis via un canvas ; null si illisible
  function rgba(str) {
    str = String(str || '').trim();
    if (!str) return null;
    var m = str.match(/^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)\s*(?:[,\/]\s*([\d.]+)(%?)\s*)?\)$/i);
    if (m) return [+m[1], +m[2], +m[3], m[4] == null ? 1 : (m[5] ? m[4] / 100 : +m[4])];
    if (str === 'transparent') return [0, 0, 0, 0];
    try {
      cvs = cvs || document.createElement('canvas').getContext('2d');
      cvs.fillStyle = 'rgba(1, 2, 3, 0.5)';
      var ref = cvs.fillStyle;
      cvs.fillStyle = str;
      if (cvs.fillStyle === ref) return null;
      cvs.clearRect(0, 0, 1, 1); cvs.fillRect(0, 0, 1, 1);
      var d = cvs.getImageData(0, 0, 1, 1).data;
      return [d[0], d[1], d[2], d[3] / 255];
    } catch (e) { return null; }
  }
  function lum(c) {
    var v = [c[0], c[1], c[2]].map(function (x) { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); });
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  }
  function contrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function over(c, bg) { var a = c[3] == null ? 1 : c[3]; return [c[0] * a + bg[0] * (1 - a), c[1] * a + bg[1] * (1 - a), c[2] * a + bg[2] * (1 - a), 1]; }
  function mix(c, d, t) { return [c[0] + (d[0] - c[0]) * t, c[1] + (d[1] - c[1]) * t, c[2] + (d[2] - c[2]) * t, 1]; }
  function trip(c) { return Math.round(c[0]) + ' ' + Math.round(c[1]) + ' ' + Math.round(c[2]); }
  function bw(c) { return contrast([0, 0, 0], c) >= contrast([255, 255, 255], c) ? [0, 0, 0, 1] : [255, 255, 255, 1]; }
  function hex(c) { return '#' + c.slice(0, 3).map(function (x) { return ('0' + Math.round(x).toString(16)).slice(-2); }).join(''); }

  // "maman:4, *fete:2" -> { maman: {w:4}, fete: {w:2, req:true} }
  function parseTags(str) {
    var out = {};
    (str || '').split(',').forEach(function (t) {
      var m = t.trim().toLowerCase().match(/^(\*?)([^:\s]+)(?::\s*(-?\d+(?:\.\d+)?))?$/);
      if (m) out[m[2]] = { w: m[3] ? +m[3] : 1, req: !!m[1] };
    });
    return out;
  }

  // Ligne "Maman | maman:4 | maman-nouveau" ; préfixe "~" = option discrète (lien sous les tuiles)
  function parseAnswers(text, images) {
    return (text || '').split(/\r?\n/).map(function (line, i) {
      var parts = line.split('|');
      var label = parts[0].trim();
      if (!label) return null;
      var extra = label.charAt(0) === '~';
      var third = (parts[2] || '').trim(), ico = /^icon\s*:/i.test(third) ? third.replace(/^icon\s*:/i, '').trim().toLowerCase() : '';
      return { label: extra ? label.slice(1).trim() : label, tags: parseTags(parts[1]), image: ico ? '' : (images && images[i]) || '', icon: ICONS[ico] ? ico : '', extra: extra };
    }).filter(Boolean);
  }

  function card(p, i, root) {
    if (!p || !p.handle) return '';
    var v = (p.variants && p.variants[0]) || {};
    var src = p.images && p.images[0] && p.images[0].src;
    var img = src ? sized(src, 500) : '';
    var conv = '_price' in p, price = conv ? p._price : v.price, cmpv = conv ? p._cmp : v.compare_at_price;
    var pr = price != null && price !== '' ? money(price) : '';
    var cmp = pr && cmpv && parseFloat(cmpv) > parseFloat(price) ? '<s>' + esc(money(cmpv)) + '</s>' : '';
    return '<a class="jtp-quiz__product" style="--i:' + i + '" href="' + esc(root + 'products/' + encodeURIComponent(p.handle)) + '">' +
      '<div class="jtp-quiz__product-media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') + '</div>' +
      '<p class="jtp-quiz__product-title">' + esc(p.title) + '</p>' +
      (pr ? '<span class="jtp-quiz__product-price">' + esc(pr) + cmp + '</span>' : '') + '</a>';
  }

  /* ---------- Petits sons (synthétisés, très discrets) ---------- */
  var actx = null;
  function audio() {
    if (!actx) { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; actx = new AC(); }
    if (actx.state === 'suspended' && actx.resume) { var p = actx.resume(); if (p && p.catch) p.catch(function () {}); }
    return actx;
  }
  // Sons feutrés « premium » : un tap doux et mat au clic, un accord chaud qui s'épanouit au résultat
  function tap() {
    var a = audio(); if (!a) return;
    var t = a.currentTime + 0.005, len = Math.floor(a.sampleRate * 0.03);
    var buf = a.createBuffer(1, len, a.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3);
    var s = a.createBufferSource(), f = a.createBiquadFilter(), g = a.createGain();
    s.buffer = buf; f.type = 'lowpass'; f.frequency.value = 1400; g.gain.value = 0.22;
    s.connect(f); f.connect(g); g.connect(a.destination); s.start(t);
    var o = a.createOscillator(), og = a.createGain();
    o.frequency.setValueAtTime(190, t); o.frequency.exponentialRampToValueAtTime(120, t + 0.07);
    og.gain.setValueAtTime(0.0001, t); og.gain.exponentialRampToValueAtTime(0.09, t + 0.004); og.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
    o.connect(og); og.connect(a.destination); o.start(t); o.stop(t + 0.1);
  }
  function chord() {
    var a = audio(); if (!a) return;
    var t = a.currentTime + 0.01, out = a.createGain(), lp = a.createBiquadFilter();
    lp.type = 'lowpass'; lp.frequency.value = 2400; out.gain.value = 1;
    out.connect(lp); lp.connect(a.destination);
    [261.6, 329.6, 392, 493.9, 587.3].forEach(function (fr, i) {   // Do majeur 9 : doux, lumineux, pas « jeu vidéo »
      [-4, 4].forEach(function (det) {
        var o = a.createOscillator(), g = a.createGain();
        o.type = 'sine'; o.frequency.value = fr; if (o.detune) o.detune.value = det;
        var st = t + i * 0.025, peak = 0.028 - i * 0.003;
        g.gain.setValueAtTime(0.0001, st); g.gain.exponentialRampToValueAtTime(peak, st + 0.25); g.gain.exponentialRampToValueAtTime(0.0001, st + 1.9);
        o.connect(g); g.connect(out); o.start(st); o.stop(st + 2);
      });
    });
  }
  var SFX = { pick: tap, success: chord };

  function Quiz(root) {
    var self = this, d = root.dataset || {};
    this.root = root;
    this.timers = [];
    this.history = [];
    this.uid = 'jtp-qz-' + (++uid);
    this.$ = function (s) { return root.querySelector(s); };
    var cfg = {};
    try { var el = this.$('[data-qz-config]'); cfg = (el && JSON.parse(el.textContent)) || {}; } catch (e) { cfg = {}; }
    this.questions = (Array.isArray(cfg.questions) ? cfg.questions : []).map(function (q) {
      q = q || {};
      return { q: q.q || '', sub: q.sub || '', answers: parseAnswers(q.answers, q.images), pickers: Array.isArray(q.pickers) ? q.pickers : [], showIf: Object.keys(parseTags(q.showIf)) };
    }).filter(function (q) { return q.answers.length; });
    this.results = (Array.isArray(cfg.results) ? cfg.results : []).filter(function (r) { return r && r.url; })
      .map(function (r) { r.tagMap = parseTags(r.tags); return r; });
    this.nProducts = Math.max(0, parseInt(d.products, 10) || 0);
    this.leadOn = d.lead === 'true';
    this.code = d.code || '';
    this.confetti = d.confetti === 'true';
    this.soundOn = d.sound === 'true';
    this.prefix = (d.phonePrefix || '').trim();
    var copyBtn = this.$('[data-qz-copy]'), shareBtn = this.$('[data-qz-share]');
    this.t = {
      copied: d.tCopied || TXT.copied, phone: d.tPhone || TXT.phone, step: d.tStep || TXT.step, copy: copyBtn ? copyBtn.textContent : '',
      resume: d.tResume || TXT.resume, share: shareBtn ? shareBtn.textContent : ''
    };
    this.leadDone = !!store.get(LEAD_KEY);

    this.probe();
    if (document.readyState !== 'complete') {
      // CSS du thème chargée en différé : nouvelle sonde après le « load », seulement si des feuilles de style
      // sont arrivées entre-temps (la sonde force un recalcul des styles de toute la page) et quand le navigateur est libre.
      var sheets = document.styleSheets.length;
      this.onLoad = function () {
        var run = function () { if (!self.dead && document.styleSheets.length !== sheets) self.probe(); };
        if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 }); else self.later(run, 200);
      };
      window.addEventListener('load', this.onLoad);
    }
    if (!this.questions.length || !this.results.length) { this.empty(); return; }

    var on = function (sel, ev, fn) { var el = self.$(sel); if (el) el.addEventListener(ev, fn); return el; };
    on('[data-qz-start]', 'click', function () { self.start(); });
    on('[data-qz-back]', 'click', function () { self.back(); });
    on('[data-qz-restart]', 'click', function () { self.history = []; self.locked = false; self.go(self.nextIndex(-1), true); self.scrollIntoView(); });
    on('[data-qz-skip]', 'click', function () { if (!self.sending) self.showResults(false); });
    on('[data-qz-copy]', 'click', function (e) { self.copy(e.currentTarget); });
    on('[data-qz-share]', 'click', function (e) { self.share(e.currentTarget); });
    this.offerResume();
    var form = on('.jtp-quiz__form', 'submit', function (e) { e.preventDefault(); self.submitLead(form); });
    // Un seul écouteur (délégation) pour toutes les réponses : rien à nettoyer entre les questions
    on('[data-qz-screen="question"]', 'click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-a]') : null;
      var a = b && self.opts ? self.opts[+b.getAttribute('data-a')] : null;
      if (a) self.pick(self.curQ, a, b.classList.contains('jtp-quiz__link') ? null : b);
    });
    on('[data-qz-answers]', 'keydown', function (e) { self.arrows(e); });
    var qt = this.$('[data-qz-question]'), list = this.$('[data-qz-answers]');
    if (qt && list) { qt.id = qt.id || this.uid + '-q'; list.setAttribute('aria-labelledby', qt.id); }

    var firstIndex = this.nextIndex(-1), first = this.questions[firstIndex], av = this.$('[data-qz-avatars]');
    if (!first) return;
    var tiles = first.answers.filter(function (a) { return !a.extra; });

    // Accueil : visuel = image choisie, sinon un éventail des photos des premières collections du quiz
    var visual = this.$('[data-qz-visual]'), hasVisual = !!(visual && visual.classList.contains('has-image'));
    if (visual && !hasVisual) {
      var seenCover = {}, covers = this.results.filter(function (r) {
        if (!r.cover || seenCover[r.cover]) return false;
        seenCover[r.cover] = 1;
        return true;
      }).slice(0, 3);
      if (covers.length) {
        visual.innerHTML = covers.map(function (r, i) {
          return '<span class="jtp-quiz__card-photo" style="--i:' + i + '"><img src="' + esc(r.cover) + '" alt="" decoding="async"' + (i ? ' loading="lazy"' : '') + '></span>';
        }).join('');
        visual.setAttribute('data-n', covers.length);
        hasVisual = true;
      }
    }
    this.root.classList.toggle('has-visual', hasVisual);

    // Sans visuel : petites vignettes (photos ou pictogrammes) des réponses de la 1re question
    var srcs = tiles.slice(0, 4).map(function (a, i) { return first.pickers[i] || a.image; });
    if (av && !hasVisual && srcs.length && srcs.every(Boolean)) {
      av.innerHTML = srcs.map(function (s) { return '<img src="' + esc(s) + '" alt="" loading="lazy" decoding="async">'; }).join('');
    } else if (av && !hasVisual) {
      var ics = tiles.filter(function (a) { return a.icon; }).slice(0, 5);
      if (ics.length) av.innerHTML = ics.map(function (a) { return '<span class="jtp-quiz__av-ico">' + icon(a.icon, 24) + '</span>'; }).join('');
    }

    // Démarrage en un clic : « Pour qui est ce cadeau ? » et ses réponses directement sur l'accueil
    var quick = this.$('[data-qz-quick]'), quickList = this.$('[data-qz-quick-list]');
    if (quick && quickList && tiles.length > 1 && tiles.length <= 6) {
      this.text('[data-qz-quick-title]', first.q);
      quickList.setAttribute('aria-label', first.q);
      quickList.innerHTML = tiles.map(function (a, i) {
        return '<button type="button" class="jtp-quiz__chip" data-quick="' + i + '" style="--i:' + i + '">' + (a.icon ? icon(a.icon, 20) : '') + '<span>' + esc(a.label) + '</span></button>';
      }).join('');
      quickList.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-quick]') : null;
        if (b) self.quickStart(firstIndex, tiles[+b.getAttribute('data-quick')], b);
      });
      quick.hidden = false;
    }
    // Précharge seulement les images de la 1re question, quand le quiz approche de l'écran (les autres : au démarrage)
    var urls = this.imagesOf(first);
    if (!urls.length) return;
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { self.preload(urls); self.unobserve(); }
      }, { rootMargin: '300px 0px' });
      this.io.observe(root);
    } else this.preload(urls);
  }

  /* ---------- Sonde du thème : couleurs, arrondis, police des titres, fond clair / sombre ---------- */
  Quiz.prototype.probe = function () {
    var root = this.root, st = root.style, cls = root.classList;
    if (!window.getComputedStyle) return;
    PROBED.forEach(function (k) { st.removeProperty(k); });
    cls.remove('qz-nobtn', 'qz-noh', 'qz-dark');
    if (!(window.CSS && CSS.registerProperty)) cls.add('qz-noprop');
    var set = function (k, v) { if (v != null && v !== '') st.setProperty(k, String(v)); };
    // Jeton résolu, accepté seulement au format « r g b » (un « r,g,b » casserait rgb(var(--x) / .1))
    var tok = function (k) {
      var v = getComputedStyle(root).getPropertyValue(k).trim();
      return /^[\d.]+\s+[\d.]+\s+[\d.]+$/.test(v) ? rgba('rgb(' + v + ')') : null;
    };
    var box = document.createElement('div');
    box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:0;overflow:hidden;visibility:hidden;pointer-events:none';
    box.innerHTML = '<a class="button">Ag</a><h2 class="h2">Ag</h2><p class="h2">Ag</p><p>Ag</p>';
    root.insertBefore(box, root.firstChild);
    try {
      var k = box.children, b = getComputedStyle(k[0]), h = getComputedStyle(k[1]), ph = getComputedStyle(k[2]), p = getComputedStyle(k[3]);
      // Fond effectif derrière le contenu : la section, puis ses ancêtres ; blanc par défaut
      var bg = null;
      for (var el = root; el && el.nodeType === 1 && !bg; el = el.parentElement) {
        var c = rgba(getComputedStyle(el).backgroundColor);
        if (c && c[3] > 0.5) bg = c;
      }
      bg = bg || [255, 255, 255, 1];
      var dark = lum(bg) < 0.4;
      // Texte : couleur héritée du thème, remplacée si illisible sur ce fond
      var tx = rgba(getComputedStyle(root.parentElement || root).color);
      if (!tx || tx[3] === 0 || contrast(over(tx, bg), bg) < 3) tx = dark ? [240, 240, 240, 1] : [26, 26, 26, 1];
      set('--qz-p-text', trip(tx));
      if (tx[3] < 1) set('--qz-p-text-a', Math.round(tx[3] * 100) / 100);
      // Accent : fond du bouton du thème (sinon sa bordure, sinon son texte) s'il se distingue du fond
      var bb = rgba(b.backgroundColor), bf = rgba(b.color), bd = parseFloat(b.borderTopWidth) || 0;
      var hasBtn = (bb && bb[3] > 0) || bd > 0 || (parseFloat(b.paddingLeft) || 0) > 0;
      if (!hasBtn) cls.add('qz-nobtn');
      var okc = function (x) { return x && x[3] > 0.5 && contrast(over(x, bg), bg) >= 1.5; };
      var acc = null;
      if (hasBtn) {
        if (okc(bb)) acc = over(bb, bg);
        else if (bd > 0 && okc(rgba(b.borderTopColor))) acc = over(rgba(b.borderTopColor), bg);
        else if (okc(bf)) acc = over(bf, bg);
      }
      if (acc) {
        set('--qz-p-accent', trip(acc));
        if (okc(bb) && bf && bf[3] > 0.5 && contrast(over(bf, acc), acc) >= 3) set('--qz-p-on-accent', trip(over(bf, acc)));
      }
      // Contrôle du résultat final (une variable d'un autre thème peut avoir un format incompatible)
      var fa = tok('--qz-accent-rgb');
      if (!fa || fa[3] === 0 || contrast(fa, bg) < 1.5) { set('--qz-p-accent', trip(tx)); fa = tok('--qz-accent-rgb') || tx; }
      var fo = tok('--qz-on-accent-rgb');
      if (!fo || fo[3] === 0 || contrast(fo, fa) < 3) set('--qz-p-on-accent', trip(bw(fa)));
      // Surface des cartes : blanche (ou --background-primary) sur fond clair ; fond éclairci de 8 % sur fond sombre
      if (dark) {
        cls.add('qz-dark');
        set('--qz-p-surface', trip(mix(bg, [255, 255, 255], 0.08)));
      } else {
        var sf = rgba(getComputedStyle(root).getPropertyValue('--qz-surface'));
        if (!sf || sf[3] === 0) set('--qz-p-surface', '255 255 255');
      }
      // Arrondis dérivés du bouton du thème (les variables Impact restent prioritaires en CSS pour les cartes)
      if (hasBtn) {
        var r = b.borderTopLeftRadius || '0', rv = parseFloat(r) || 0;
        if (r.indexOf('%') > -1) rv = rv ? 999 : 0;
        set('--qz-p-btn-radius', rv + 'px');
        set('--qz-p-radius', Math.min(rv, 12) + 'px');
      }
      // Titres : police du thème ; tailles de repli seulement si le thème n'a pas de classe .h2
      set('--qz-heading-font', h.fontFamily);
      set('--qz-heading-weight', h.fontWeight);
      var fz = parseFloat(h.fontSize), ls = parseFloat(h.letterSpacing);
      set('--qz-heading-ls', fz && isFinite(ls) ? Math.round(ls / fz * 1000) / 1000 + 'em' : 'normal');
      if (ph.fontSize === p.fontSize && ph.fontFamily === p.fontFamily && ph.fontWeight === p.fontWeight) cls.add('qz-noh');
    } catch (e) {}
    if (box.parentNode) box.parentNode.removeChild(box);
  };

  Quiz.prototype.later = function (fn, ms) {
    var self = this;
    this.timers.push(setTimeout(function () { if (!self.dead) fn(); }, ms));
  };
  Quiz.prototype.text = function (sel, v) { var el = this.$(sel); if (el) el.textContent = v == null ? '' : v; return el; };
  // Annonce pour lecteurs d'écran (région aria-live)
  Quiz.prototype.say = function (msg) {
    var el = this.$('[data-qz-live]');
    if (!el || !msg) return;
    el.textContent = '';
    this.later(function () { el.textContent = msg; }, 80);
  };
  // Déplace le focus seulement s'il était dans le quiz (ou perdu) : jamais de vol de focus ailleurs dans la page
  Quiz.prototype.focus = function (el) {
    var a = document.activeElement;
    if (!el || (a && a !== document.body && !this.root.contains(a))) return;
    try { el.focus({ preventScroll: true }); } catch (e) {}
  };
  Quiz.prototype.sfx = function (name) { if (this.soundOn) try { SFX[name](); } catch (e) {} };
  Quiz.prototype.unobserve = function () { if (this.io) { this.io.disconnect(); this.io = null; } };
  Quiz.prototype.imagesOf = function (q) {
    return q.answers.filter(function (a) { return !a.extra; }).map(function (a, i) { return q.pickers[i] || a.image; }).filter(Boolean);
  };
  Quiz.prototype.preload = function (urls) {
    var seen = this.seen || (this.seen = {});
    urls.forEach(function (u) { if (u && !seen[u]) { seen[u] = 1; var i = new Image(); i.decoding = 'async'; i.src = u; } });
  };
  Quiz.prototype.preloadAll = function () {
    var self = this, all = [];
    this.questions.forEach(function (q) { all = all.concat(self.imagesOf(q)); });
    var run = function () { if (!self.dead) self.preload(all); };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 }); else this.later(run, 300);
  };
  Quiz.prototype.empty = function () {
    var n = this.$('[data-qz-notice]'), s = this.$('[data-qz-start]');
    if (n) { n.hidden = false; if (s) s.disabled = true; }   // éditeur de thème : message au marchand
    else this.root.style.display = 'none';                     // boutique : quiz non configuré = masqué
  };
  // Hauteur figée pendant le chargement : la page ne « saute » pas entre la dernière question et le résultat
  Quiz.prototype.lockStage = function (on) {
    var st = this.$('[data-qz-stage]');
    if (st) st.style.minHeight = on ? Math.min(st.offsetHeight, Math.round(window.innerHeight * 0.75)) + 'px' : '';
  };

  Quiz.prototype.scrollIntoView = function () {
    var r = this.root.getBoundingClientRect();
    if (r.top < -40 || r.top > window.innerHeight * 0.35) {
      try { this.root.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); } catch (e) { this.root.scrollIntoView(true); }
    }
  };

  Quiz.prototype.profile = function () {
    var p = {};
    this.history.forEach(function (h) { Object.keys(h.a.tags).forEach(function (t) { p[t] = (p[t] || 0) + h.a.tags[t].w; }); });
    return p;
  };
  Quiz.prototype.eligible = function (q, p) { return !q.showIf.length || q.showIf.some(function (t) { return p[t] > 0; }); };
  Quiz.prototype.nextIndex = function (from) {
    var p = this.profile();
    for (var i = from + 1; i < this.questions.length; i++) if (this.eligible(this.questions[i], p)) return i;
    return -1;
  };
  Quiz.prototype.estimate = function (from) {
    var p = this.profile(), n = this.history.length;
    for (var i = from; i < this.questions.length; i++) if (this.eligible(this.questions[i], p)) n++;
    return n;
  };

  // Transition entre écrans (glisse vers la gauche, ou la droite quand on revient en arrière)
  Quiz.prototype.show = function (name, cb, back) {
    var self = this;
    var cur = this.root.querySelector('[data-qz-screen]:not([hidden])');
    var swap = function () {
      var scr = null;
      each(self.root.querySelectorAll('[data-qz-screen]'), function (s) {
        s.hidden = s.getAttribute('data-qz-screen') !== name;
        s.classList.remove('is-leaving', 'is-back');
        if (!s.hidden) scr = s;
      });
      if (!scr) return;
      scr.classList.toggle('is-back', !!back);
      scr.style.animation = 'none'; void scr.offsetWidth; scr.style.animation = '';
      var top = self.$('[data-qz-top]');
      if (top) top.hidden = name !== 'question';
      if (cb) cb(scr);
    };
    if (cur && !reduced()) { cur.classList.toggle('is-back', !!back); cur.classList.add('is-leaving'); this.later(swap, 280); } else swap();
  };

  Quiz.prototype.progress = function (width, pct, label) {
    var bar = this.$('[data-qz-bar]'), pb = this.$('[data-qz-progress]');
    if (bar) bar.style.width = width + '%';
    if (pb) { pb.setAttribute('aria-valuenow', Math.round(pct)); if (label) pb.setAttribute('aria-valuetext', label); }
  };

  Quiz.prototype.start = function () { this.unobserve(); this.preloadAll(); this.go(this.nextIndex(-1)); };
  // Réponse choisie directement sur l'accueil : comptée comme 1re réponse, le quiz enchaîne sur la question suivante
  Quiz.prototype.quickStart = function (qi, a, chip) {
    if (this.locked || !a) return;
    this.unobserve();
    this.preloadAll();
    this.history = [];
    this.curQ = qi;
    this.pick(qi, a, chip);
  };

  Quiz.prototype.go = function (qi, back) {
    var self = this, q = this.questions[qi];
    if (!q) return this.finish();
    this.show('question', function () {
      self.locked = self.busy = false;
      var done = self.history.length, total = Math.max(self.estimate(qi), done + 1);
      var step = self.t.step.replace('{n}', done + 1).replace('{total}', total);
      self.progress(Math.max(6, done / total * 100), done / total * 100, step);
      self.text('[data-qz-step]', (done + 1) + '/' + total);
      var bk = self.$('[data-qz-back]');
      if (bk) bk.disabled = done === 0;
      var title = self.text('[data-qz-question]', q.q);
      self.text('[data-qz-sub]', q.sub);
      self.curQ = qi;
      var list = self.$('[data-qz-answers]'), extra = self.$('[data-qz-extra]');
      var tiles = q.answers.filter(function (a) { return !a.extra; }), extras = q.answers.filter(function (a) { return a.extra; });
      self.opts = tiles.concat(extras);
      // Tuiles photo uniquement si CHAQUE réponse a sa photo ; sinon cartes texte à cocher (jamais de mélange)
      var imgs = tiles.map(function (a, i) { return q.pickers[i] || a.image; });
      var photo = imgs.length > 0 && imgs.every(Boolean);
      var iconMode = !photo && tiles.length > 0 && tiles.every(function (a) { return a.icon; });
      if (list) {
        list.setAttribute('data-n', tiles.length);
        list.classList.toggle('is-text', !photo && !iconMode);
        list.classList.toggle('is-icon', iconMode);
        list.innerHTML = tiles.map(function (a, i) {
          var attrs = ' type="button" data-a="' + i + '" style="--i:' + i + '"';
          if (iconMode) return '<button class="jtp-quiz__ico"' + attrs + '>' + CHECK + '<span class="jtp-quiz__ico-badge">' + icon(a.icon) + '</span><span class="jtp-quiz__ico-label">' + esc(a.label) + '</span></button>';
          return photo
            ? '<button class="jtp-quiz__tile"' + attrs + '>' + CHECK + '<span class="jtp-quiz__tile-media"><img src="' + esc(imgs[i]) + '" alt="" draggable="false" decoding="async"></span><span class="jtp-quiz__tile-label">' + esc(a.label) + '</span></button>'
            : '<button class="jtp-quiz__opt"' + attrs + '><span class="jtp-quiz__radio" aria-hidden="true">' + RADIO + '</span><span class="jtp-quiz__opt-label">' + esc(a.label) + '</span></button>';
        }).join('');
      }
      if (extra) {
        extra.innerHTML = extras.map(function (a, j) {
          return '<button type="button" class="jtp-quiz__link" data-a="' + (tiles.length + j) + '">' + esc(a.label) + '</button>';
        }).join('');
      }
      self.say(step);
      self.focus(title);
    }, back);
    if (this.history.length) this.scrollIntoView();
  };

  // Flèches / Début / Fin pour passer d'une réponse à l'autre au clavier (Tab fonctionne aussi)
  Quiz.prototype.arrows = function (e) {
    var k = e.key, dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[k];
    if (!dir && k !== 'Home' && k !== 'End') return;
    if ((k === 'ArrowRight' || k === 'ArrowLeft') && getComputedStyle(this.root).direction === 'rtl') dir = -dir;
    var btns = Array.prototype.slice.call(e.currentTarget.querySelectorAll('button'));
    var i = btns.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    btns[k === 'Home' ? 0 : k === 'End' ? btns.length - 1 : (i + dir + btns.length) % btns.length].focus();
  };

  Quiz.prototype.pick = function (qi, a, tile) {
    if (this.locked) return;
    this.locked = true;
    this.sfx('pick');
    if (navigator.vibrate) try { navigator.vibrate(8); } catch (e) {}
    var list = this.$('[data-qz-answers]');
    if (tile) tile.classList.add('is-picked');
    if (list) each(list.children, function (c) { if (c !== tile) c.classList.add('is-dim'); });
    this.history.push({ qi: qi, a: a });
    var self = this, total = Math.max(this.estimate(qi + 1), this.history.length), pct = this.history.length / total * 100;
    this.progress(pct, pct);
    this.later(function () {
      var next = self.nextIndex(qi);
      if (next > -1) self.go(next); else self.finish();
    }, reduced() ? 300 : 650);
  };

  Quiz.prototype.back = function () {
    if (this.locked) return;
    var last = this.history.pop();
    if (last) { this.locked = true; this.go(last.qi, true); }
  };

  Quiz.prototype.rank = function () {
    var p = this.profile();
    return this.results.map(function (r, idx) {
      var s = 0, ok = true;
      Object.keys(r.tagMap).forEach(function (t) {
        if (p[t]) s += p[t] * r.tagMap[t].w;
        else if (r.tagMap[t].req) ok = false;
      });
      return { r: r, s: ok ? s : -1, idx: idx };
    }).sort(function (a, b) { return b.s - a.s || a.idx - b.idx; });
  };

  Quiz.prototype.fetchList = function (r, limit) {
    var url = r && (r.feed || (r.handle ? rootUrl() + 'collections/' + encodeURIComponent(r.handle) + '/products.json' : ''));
    if (!url) return Promise.resolve([]);   // résultat « lien seul » : pas de produits
    return getJSON(url + (url.indexOf('?') > -1 ? '&' : '?') + 'limit=' + limit)
      .then(function (d) { return d && Array.isArray(d.products) ? d.products : []; })
      .catch(function () { return []; });
  };

  // Produits proposés = collection gagnante (le destinataire) + 2 collections voisines,
  // classés selon TOUTES les réponses (les tags servent de mots-clés sur titre / type / tags produit).
  // Garantie : chaque réponse « principale » (1er tag de chaque réponse : maman, t-shirt, photo…) est représentée
  // par au moins un produit si le catalogue en contient un — de préférence un produit qui coche aussi les autres réponses.
  Quiz.prototype.loadProducts = function (best, alts) {
    var self = this, n = this.nProducts;
    if (n <= 0 || !best) return Promise.resolve([]);
    var srcs = [best].concat((alts || []).slice(0, 2));
    return Promise.all(srcs.map(function (r, i) { return self.fetchList(r, i === 0 ? 50 : 30); }))
      .then(function (lists) { return presentment(self.choose(lists, n)); })
      .catch(function () { return []; });
  };

  Quiz.prototype.choose = function (lists, n) {
    var prof = this.profile(), keys = Object.keys(prof).filter(function (k) { return prof[k] > 0; });
    var primaries = [];
    this.history.slice().sort(function (a, b) { return mainW(b.a) - mainW(a.a); }).forEach(function (h) {
      var k = Object.keys(h.a.tags)[0];
      if (k && primaries.indexOf(k) < 0) primaries.push(k);
    });
    function mainW(a) { var k = Object.keys(a.tags)[0]; return k ? a.tags[k].w : 0; }
    var seen = {}, cands = [];
    lists.forEach(function (list, si) {
      list.forEach(function (p, pi) {
        if (!p || !p.handle || seen[p.handle]) return;
        seen[p.handle] = 1;
        var ws = words(p), match = {}, s = (si === 0 ? 2 : 0) - pi * 0.01;   // bonus collection gagnante, puis ordre du marchand
        keys.forEach(function (k) { if (hit(ws, k)) { match[k] = 1; s += prof[k]; } });
        cands.push({ p: p, s: s, match: match });
      });
    });
    cands.sort(function (a, b) { return b.s - a.s; });
    var pick = cands.slice(0, n), kept = [];
    primaries.forEach(function (k) {
      var have = pick.filter(function (c) { return c.match[k]; });
      if (have.length) { if (kept.indexOf(have[0]) < 0) kept.push(have[0]); return; }
      var c = null;
      for (var i = 0; i < cands.length; i++) if (cands[i].match[k] && pick.indexOf(cands[i]) < 0) { c = cands[i]; break; }
      if (!c) return;
      if (pick.length < n) { pick.push(c); kept.push(c); return; }
      for (var j = pick.length - 1; j >= 0; j--) if (kept.indexOf(pick[j]) < 0) { pick[j] = c; kept.push(c); return; }
    });
    pick.sort(function (a, b) { return b.s - a.s; });
    return pick.map(function (c) { return c.p; });
  };

  Quiz.prototype.finish = function () {
    var self = this, ranked = this.rank();
    var best = ranked[0] && ranked[0].s > 0 ? ranked[0].r : this.results[this.results.length - 1];
    if (!best) return;
    this.best = best;
    this.alts = ranked.filter(function (x) { return x.s > 0 && x.r !== best; }).slice(0, 3).map(function (x) { return x.r; });
    this.productsPromise = this.loadProducts(best, this.alts);
    if (this.confetti && !reduced()) loadConfetti().catch(function () {});
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'jtp_quiz_result', quiz_result: best.handle || best.url, quiz_answers: this.history.map(function (h) { return h.a.label; }).join(' > ') });
    } catch (e) {}

    if (this.leadOn && !this.leadDone && this.$('.jtp-quiz__form')) {
      this.show('lead', function (scr) {
        var eb = scr.querySelector('.jtp-quiz__eyebrow');
        if (eb) self.say(eb.textContent);
        self.focus(scr.querySelector('[data-qz-lead-title]'));
      });
    } else this.showResults(false);
  };

  Quiz.prototype.submitLead = function (form) {
    if (this.sending) return;
    var self = this, best = this.best || {}, err = this.$('[data-qz-error]'), btn = this.$('[data-qz-submit]');
    var emailEl = form.querySelector('[name="contact[email]"]'), phoneEl = form.querySelector('[data-qz-phone]');
    var email = emailEl ? emailEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.replace(/[^\d+]/g, '') : '';
    if (phone && phone.length < 9) {
      if (err) { err.hidden = false; err.textContent = this.t.phone; }
      phoneEl.setAttribute('aria-invalid', 'true');
      try { phoneEl.focus(); } catch (e) {}
      return;
    }
    if (err) err.hidden = true;
    if (phoneEl) phoneEl.removeAttribute('aria-invalid');
    // Tags client = segmentation automatique pour vos emails / SMS (quiz-maman, quiz-livre…)
    var tags = ['quiz', 'quiz-' + (best.handle || 'resultat')];
    Object.keys(this.profile()).slice(0, 8).forEach(function (t) { tags.push('quiz-' + t); });
    if (phone) tags.push('tel-' + phone);
    var tagsEl = form.querySelector('[data-qz-tags]');
    if (tagsEl) tagsEl.value = tags.join(', ');
    this.sending = true;
    if (btn) btn.disabled = true;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        var props = { email: email, quiz_result: best.title };
        if (phone) props.phone_number = this.prefix ? phone.replace(/^00/, '+').replace(/^0/, this.prefix) : phone;
        var kp = window.klaviyo.identify(props);
        if (kp && kp.catch) kp.catch(function () {});
      }
    } catch (e) {}
    post(form).then(function (ok) {
      if (self.dead) return;
      self.sending = false;
      if (btn) btn.disabled = false;
      self.leadDone = true;                 // pas redemandé pendant cette visite
      if (ok) store.set(LEAD_KEY, '1');     // ni aux suivantes, si l'inscription est bien passée
      self.showResults(true);
    });
  };

  // Visiteur qui revient : raccourci vers sa dernière sélection (si ce résultat existe toujours)
  Quiz.prototype.offerResume = function () {
    var self = this, btn = this.$('[data-qz-resume]'), last = null;
    try { last = JSON.parse(store.get(LAST_KEY) || 'null'); } catch (e) {}
    if (!btn || !last || !last.url || Date.now() - (last.t || 0) > LAST_DAYS * 864e5) return;
    var known = this.results.filter(function (r) { return r.url === last.url; })[0];
    if (!known) return;
    btn.textContent = this.t.resume + ' : ' + known.title;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      self.unobserve();
      self.history = [];
      self.best = known;
      self.alts = [];
      self.productsPromise = self.loadProducts(known, []);
      self.showResults(false);
    });
  };

  Quiz.prototype.share = function (btn) {
    var self = this, best = this.best;
    if (!best || !btn) return;
    var url = best.url, text = best.title + (best.text ? ' — ' + best.text : '');
    try { url = new URL(best.url, window.location.href).href; } catch (e) {}
    var copied = function () { btn.textContent = self.t.copied; self.say(self.t.copied); };
    try {
      // Partage natif sur téléphone (WhatsApp, SMS…), sinon lien copié
      if (navigator.share) { navigator.share({ title: best.title, text: text, url: url }).catch(function () {}); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text + ' ' + url).then(copied, function () {});
    } catch (e) {}
  };

  Quiz.prototype.copy = function (btn) {
    var self = this, code = this.code;
    if (!code || !btn) return;
    var done = function () { btn.textContent = self.t.copied; self.say(self.t.copied); };
    var legacy = function () {
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;pointer-events:none';
        document.body.appendChild(ta); ta.select();
        var ok = document.execCommand && document.execCommand('copy');
        document.body.removeChild(ta);
        if (ok) done();
      } catch (e) {}
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, legacy);
      else legacy();
    } catch (e) { legacy(); }
  };

  Quiz.prototype.celebrate = function () {
    this.sfx('success');
    if (!this.confetti || reduced() || typeof window.confetti !== 'function') return;
    try {
      var acc = rgba('rgb(' + getComputedStyle(this.root).getPropertyValue('--qz-accent-rgb').trim() + ')');
      var colors = [acc ? hex(acc) : '#ac3c4b', '#f0c417', '#ffffff', '#f6b8c2'];
      var r = this.root.getBoundingClientRect();
      var y = Math.min(0.6, Math.max(0.15, (r.top + 120) / window.innerHeight));
      window.confetti({ particleCount: 90, spread: 70, startVelocity: 42, origin: { x: 0.5, y: y }, colors: colors, scalar: 0.9, ticks: 220, disableForReducedMotion: true });
      this.later(function () {
        try {
          window.confetti({ particleCount: 40, angle: 60, spread: 55, origin: { x: 0, y: y + 0.1 }, colors: colors, disableForReducedMotion: true });
          window.confetti({ particleCount: 40, angle: 120, spread: 55, origin: { x: 1, y: y + 0.1 }, colors: colors, disableForReducedMotion: true });
        } catch (e) {}
      }, 220);
    } catch (e) {}
  };

  Quiz.prototype.showResults = function (withCode) {
    var self = this, best = this.best;
    if (!best || this.busy) return;
    this.busy = true;
    this.lockStage(true);
    this.show('loading', function (scr) { var p = scr.querySelector('.jtp-quiz__lead'); if (p) self.say(p.textContent); });
    var wait = new Promise(function (res) { self.later(res, 1200); });
    // Produits : jamais bloquant (erreur, 404, lenteur > 6 s => résultat sans produits)
    var feed = Promise.race([this.productsPromise || Promise.resolve([]), new Promise(function (res) { self.later(function () { res([]); }, 6000); })]);
    Promise.all([feed, wait]).then(function (res) {
      var products = res[0] || [], root = rootUrl();
      self.show('result', function (scr) {
        var title = self.text('[data-qz-r-title]', best.title);
        self.text('[data-qz-r-text]', best.text);
        var link = self.$('[data-qz-r-link]');
        if (link) link.setAttribute('href', best.url);
        var code = self.$('[data-qz-code]');
        if (code) code.hidden = !(withCode && self.code);
        self.text('[data-qz-code-value]', self.code);
        var copy = self.$('[data-qz-copy]');
        if (copy && self.t.copy) copy.textContent = self.t.copy;
        var share = self.$('[data-qz-share]');
        if (share && self.t.share) share.textContent = self.t.share;
        store.set(LAST_KEY, JSON.stringify({ url: best.url, t: Date.now() }));
        var grid = self.$('[data-qz-products]');
        if (grid) grid.innerHTML = products.map(function (p, i) { return card(p, i, root); }).join('');
        var wrap = self.$('[data-qz-alts-wrap]'), alts = self.$('[data-qz-alts]');
        if (wrap) wrap.hidden = !self.alts.length;
        if (alts) {
          alts.innerHTML = self.alts.map(function (r) {
            return '<a class="jtp-quiz__alt" href="' + esc(r.url) + '">' + (r.image ? '<img src="' + esc(r.image) + '" alt="" loading="lazy" decoding="async" width="30" height="30">' : '<i></i>') + esc(r.title) + '</a>';
          }).join('');
        }
        self.lockStage(false);
        var eb = scr.querySelector('.jtp-quiz__eyebrow');
        self.say((eb ? eb.textContent + ' : ' : '') + (best.title || ''));
        self.focus(title);
        self.later(function () { self.celebrate(); }, 250);
      });
      self.scrollIntoView();
    });
  };

  Quiz.prototype.destroy = function () {
    this.dead = true;
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.unobserve();
    if (this.onLoad) window.removeEventListener('load', this.onLoad);
    if (this.root.__jtpQuiz === this) delete this.root.__jtpQuiz;
  };

  function scan(scope) {
    scope = scope || document;
    var out = scope.matches && scope.matches('[data-jtp-quiz]') ? [scope] : [];
    return out.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll('[data-jtp-quiz]') : []));
  }
  function init(scope) {
    if (!window.Promise || !window.JSON) return;
    scan(scope).forEach(function (el) {
      if (el.__jtpQuiz) return;
      try { el.__jtpQuiz = new Quiz(el); } catch (e) { if (window.console) console.error('[jtp-quiz]', e); }
    });
  }
  function destroy(scope) { scan(scope).forEach(function (el) { if (el.__jtpQuiz) el.__jtpQuiz.destroy(); }); }
  window.JtpQuiz = { init: init, destroy: destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Éditeur de thème : ré-initialisation propre quand la section est rechargée / retirée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
